export * from './key-map-dialog'

export const KEY_MAP: { keyName: string; cubeMovement?: string }[] = [
  { keyName: '1', cubeMovement: "S'" },
  { keyName: '2', cubeMovement: 'E' },
  { keyName: '3' },
  { keyName: '4' },
  { keyName: '5', cubeMovement: 'M' },
  { keyName: '6', cubeMovement: 'M' },
  { keyName: '7' },
  { keyName: '8' },
  { keyName: '9', cubeMovement: "E'" },
  { keyName: '0', cubeMovement: 'S' },
  { keyName: 'Q', cubeMovement: "z'" },
  { keyName: 'W', cubeMovement: 'B' },
  { keyName: 'E', cubeMovement: "L'" },
  { keyName: 'R', cubeMovement: "Lw'" },
  { keyName: 'T', cubeMovement: 'x' },
  { keyName: 'Y', cubeMovement: 'x' },
  { keyName: 'U', cubeMovement: 'Rw' },
  { keyName: 'I', cubeMovement: 'R' },
  { keyName: 'O', cubeMovement: "B'" },
  { keyName: 'P', cubeMovement: 'z' },
  { keyName: 'A', cubeMovement: "y'" },
  { keyName: 'S', cubeMovement: 'D' },
  { keyName: 'D', cubeMovement: 'L' },
  { keyName: 'F', cubeMovement: "U'" },
  { keyName: 'G', cubeMovement: "F'" },
  { keyName: 'H', cubeMovement: 'F' },
  { keyName: 'J', cubeMovement: 'U' },
  { keyName: 'K', cubeMovement: "R'" },
  { keyName: 'L', cubeMovement: "D'" },
  { keyName: ';', cubeMovement: 'y' },
  { keyName: 'Z', cubeMovement: 'Dw' },
  { keyName: 'X', cubeMovement: "M'" },
  { keyName: 'C', cubeMovement: "Uw'" },
  { keyName: 'V', cubeMovement: 'Lw' },
  { keyName: 'B', cubeMovement: "x'" },
  { keyName: 'N', cubeMovement: "x'" },
  { keyName: 'M', cubeMovement: "Rw'" },
  { keyName: ',', cubeMovement: 'Uw' },
  { keyName: '.', cubeMovement: "M'" },
  { keyName: '/', cubeMovement: "Dw'" },
]
